import { Component } from "@angular/core";
import { Lottie } from "../../constant/lottie";
import { LoaderService } from "../../services/loader.service";

@Component({
    selector: "app-loader",
    templateUrl: "./loader.component.html",
    styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent {
    constructor(public lottie: Lottie, public loaderService: LoaderService) { }
}
